import React, { useState } from 'react';
import classes from './style.module.css'
import { Col } from 'react-bootstrap';
import ProfileMenu from "../UI/ProfileMenu"
import ExportData from "../ExportData"
import { SET_SELECTION_STATE, SET_SOCCER_LEAGUES_STATE, SET_SOCCER_MATCHES_STATE } from "../../redux/actions"
import { connect } from "react-redux"
import { HEADER_CONTROLS } from "../../constants/Constants"
import { passDateToString } from '../../util/date/date-utils'
import { currentDateStr } from '../../util/date/date-utils'
import DatePicker from '../../components/UI/DatePicker'
import bookIcon from "../../assets/images/book.png"
//import RaceSlidingPane from '../RaceSlidingPane';
import "react-sliding-pane/dist/react-sliding-pane.css";
import Clock from 'react-live-clock';

const Header = props => {
    const [selectionDate, setSelectionDate] = useState(currentDateStr())
    const [isShowLogin, setIsShowLogin] = useState(false);

    const handleLoginClick = () => {
        console.log(".....clicked")
        setIsShowLogin((isShowLogin) => !isShowLogin);
      };

    const selectionDateChangeHandler = (event) => {
        const newDate = passDateToString(event);
        const selectionState = { ...props.selectionState };
        selectionState.selectionDate = newDate;
        props.setSelectionState(selectionState);
        setSelectionDate(newDate)
    }

    return (
        <>
            <Col className={classes.HeaderLeft} xs={8}>
                <ExportData label={HEADER_CONTROLS.EXPORT_DATA_BUTTON.label} mode={props.selectionState.mode}
                    selectionDate={props.selectionState.selectionDate}
                    currentTab={props.selectionState.tab}
                    home={props.selectionState.home}
                    away={props.selectionState.away} />

                <a href="https://winningmore.com/manual.htm" target="_blank" rel="noopener noreferrer" className={classes.ManualLink}>
                    <img className={classes.ManualIcon} src={bookIcon} alt="Manual" />
                    <span>User Guide</span>
                </a>

                <div className={classes.ClockWrapper}>
                    <span style={{opacity: 0.9}}>🕐</span>
                    <span>GMT Time:</span>
                    <Clock format={'HH:mm:ss, DD/MM/YYYY'} ticking={true} timezone={'GMT'} />
                </div>
            </Col>
            <Col className={classes.HeaderRight} xs={4}>
                <DatePicker selectedDate={selectionDate} selectedDateChanged={selectionDateChangeHandler} />
                <ProfileMenu logoutClicked={props.logoutClicked} />
            </Col>
        </>
    );
}

const mapStateToProps = (state, ownProps) => {
    return {
        selectionState: state.selectionState,
        ...ownProps
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSoccerLeaguesState: payload =>
            dispatch({ type: SET_SOCCER_LEAGUES_STATE, payload: payload }),
        setSelectionState: payload =>
            dispatch({ type: SET_SELECTION_STATE, payload: payload }),
        setSoccerMatchesState: payload =>
            dispatch({ type: SET_SOCCER_MATCHES_STATE, payload: payload }),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);